import compose from "recompose/compose";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

const EnhanceLayout = ({ NavigationMenuQuery }) =>
  compose(
    injectIntl,
    graphql(NavigationMenuQuery, {
      name: "categories",
    })
  );

export default EnhanceLayout;
